module.exports = "<div id=\"body-warper\">\n  <div id=\"main-body\" class=\"container-fluid d-flex no-gutters\">\n    <div *ngIf=\"statusBar\" id=\"overlay-nav\" class=\"\" (click)=\"closeMenu()\"></div>\n    <div id=\"nav\" class=\"col col-auto\">\n      <app-left-slider [statusBar]=\"statusBar\"\n                       (closeMenuEvent)=\"statusBar = $event\"></app-left-slider>\n    </div>\n    <!-- Este  div es el warper para el render de angular-->\n    <router-outlet></router-outlet>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/base-component/main.component.html
// module id = ./src/app/base-component/main.component.html
// module chunks = main